import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { TextArea, Input, DatePicker } from 'components/tt-forms/common';
import { Dialog } from "@blueprintjs/core";
import { LetterProcessingWorkFlow, GiaiQuyetDonThu } from 'api';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message'
import { Reception } from 'api';
import { checkServerLive, LimitFileSize, LimitFileType } from 'constants/config';
import { ShowIf } from 'components/utils';
import fileDownload from 'js-file-download';
import { downloadFile } from 'components/utils';

const loaiTepDinhKem = 'QUYET_DINH';
const buocGiaiQuyet = 'DINH_CHI_DON';
const loaiQuyTrinh = 'GIAI_QUYET_DON';
const ten = 'Phiếu đình chỉ';

class SuspendedDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      isValid: false,
      btnLoading: false,
      soQuyetDinhDinhChi: '',
      ngayQuyetDinhDinhChi: '',
      ngayRutDon: '',
      lyDoDinhChi: '',
      id: this.props.id,
      type: this.props.type,

      tenFile: '',
      urlFile: '',
      progress: 0,
      duongDan: '',
      emptyFile: false
    }
  }

  closeDialog() {
    this.setState({
      isValid: false,
      btnLoading: false,
      soQuyetDinhDinhChi: '',
      ngayQuyetDinhDinhChi: '',
      lyDoDinhChi: '',
      tenFile: '',
      urlFile: '',
      progress: 0,
      duongDan: '',
      emptyFile: false,
      isOpen: !this.state.isOpen
    });
  }

  openDialog() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  handleDinhChi() {
    if (this.validateSubmitForm()) {
      this.setState({
        btnLoading: true
      });
      let params = {
        lyDoDinhChi: this.state.lyDoDinhChi,
        ngayQuyetDinhDinhChi: moment(this.state.ngayQuyetDinhDinhChi).add(7, 'hours').toISOString(),
        soQuyetDinhDinhChi: this.state.soQuyetDinhDinhChi
      }
      if (this.state.type == 'GIAI_QUYET_DON') {
        if (this.state.duongDan != '' && this.props.loaiDon != 'DON_KIEN_NGHI_PHAN_ANH') {
          let params = {
            buocGiaiQuyet: buocGiaiQuyet,
            don: {
              id: this.state.id
            },
            duongDan: this.state.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            loaiTepDinhKem: loaiTepDinhKem,

            tenFile: this.state.tenFile,
            ten: ten,
            ngayQuyetDinh: moment(this.state.ngayQuyetDinhDinhChi).add(7, 'hours').toISOString(),
            soQuyetDinh: this.state.soQuyetDinhDinhChi
          }
          if (this.props.loaiDon == 'DON_KHIEU_NAI') {
            params.ten = 'Quyết định về việc đình chỉ giải quyết khiếu nại';
          } else if (this.props.loaiDon == 'DON_TO_CAO') {
            params.ten = 'Quyết định đình chỉ tố cáo';
          } else {
            params.ten = ten;
          }
          this.postTaiLieuVanThu(params);
        }
      }

      if (this.state.type == "XU_LY_DON") {

        if (this.state.duongDan != '') {
          let params = {
            buocGiaiQuyet: buocGiaiQuyet,
            don: {
              id: this.state.id
            },
            duongDan: this.state.duongDan,
            loaiQuyTrinh: 'XU_LY_DON',
            loaiTepDinhKem: loaiTepDinhKem,

            tenFile: this.state.tenFile,
            ngayQuyetDinh: moment(this.state.ngayQuyetDinhDinhChi).add(7, 'hours').toISOString(),
            soQuyetDinh: this.state.soQuyetDinhDinhChi
          }
          if (this.props.trangThaiDon == 'DANG_XU_LY') {
            params.ten = 'Đơn xin rút đơn';
          } else {
            if (this.props.loaiDon == 'DON_KHIEU_NAI') {
              params.ten = 'Quyết định về việc đình chỉ giải quyết khiếu nại';
            } else if (this.props.loaiDon == 'DON_TO_CAO') {
              params.ten = 'Quyết định đình chỉ tố cáo';
            } else {
              params.ten = ten;
            }
          }
          this.postTaiLieuVanThu(params);
        }

        params.yKienXuLy = params.lyDoDinhChi;
        params.don = {
          id: this.state.id
        }
        delete params['lyDoDinhChi'];
        this.dinhChiXuLyDon(params);
      } else {
        this.dinhChiGiaiQuyetDon(params);
      }
    }
  }

  dinhChiXuLyDon(params) {
    LetterProcessingWorkFlow.actions.patchDinhChiDon.request({ id: this.state.id }, params).then(res => {
      if (this.props.trangThaiDon == 'DANG_XU_LY') {
        Toastr(msg.rutDon, 'success');
      } else {
        Toastr(msg.dinhChiDon, 'success');
      }
      this.setState({
        isOpen: !this.state.isOpen,
        btnLoading: false
      });
      this.props.getListData();

    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        btnLoading: false
      });

    });
  }

  dinhChiGiaiQuyetDon(params) {
    GiaiQuyetDonThu.actions.dinhChiGiaiQuyetDon.request({ id: this.state.id }, params).then(res => {
      Toastr(msg.dinhChiDon, 'success');
      this.setState({
        isOpen: !this.state.isOpen,
        btnLoading: false
      });
      this.props.getListData();

    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      this.setState({
        btnLoading: false
      });

    });
  }

  onChange(name, e) {
    if (e._d) {
      this.setState({
        [name]: e._d
      })
    } else if (e.target) {
      this.setState({
        [name]: e.target.value
      })
    } else {
      this.setState({
        [name]: e
      })
    }
  }

  validateSubmitForm() {
    let pass = true;
    if (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' && this.props.trangThaiDon == 'DANG_GIAI_QUYET') {
      //do nothing
    } else {
      if (this.state.duongDan == '') {
        pass = false;
        this.setState({
          emptyFile: true
        })
      }
    }
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  uploadFile(e) {
    if (e.target.files[0]) {
      let fileName = e.target.files[0].name;
      let ext = fileName.split('.').pop().toLowerCase();
      let fileSize = e.target.files[0].size;
      if (LimitFileType.indexOf(ext) == -1) {
        Toastr(msg.fileTypeErr, 'warning');
      } else if (fileSize > LimitFileSize * 1024 * 1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {
        let params = { field: 'file', file: e.target.files[0] };

        params.progress = (progress) => {
          let progressBar = Math.round((progress.loaded * 100) / progress.total);

          this.setState({ progress: progressBar });
        }

        Reception.actions.postFileUpload.request('', params).then(res => {
          let checkURL = '';
          if (res && res.data && !checkServerLive) {
            checkURL = res.data;
          } else if (res && res.data && checkServerLive) {
            checkURL = res.data.id;
          }
          this.setState({
            progress: 0,
            tenFile: fileName,
            duongDan: res.data ? res.data.id : ''
          });
        });

      }
    }
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKemDon.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  handleRemove(index) {
    this.setState({
      duongDan: '',
      tenFile: '',
      progress: 0
    })
  }

  render() {

    return (
      <div className="wrap-link-todo">
        <Link className="itt-rutdon" onClick={this.openDialog.bind(this)}>Rút đơn</Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.closeDialog.bind(this)}
          title="Rút đơn"
          className="dialog-gh wrap-block">
          <div className="body-dialog-gh">
            <div className="row pl30 pr30 pt20">
              <ShowIf condition={this.props.trangThaiDon == 'DANG_XU_LY'}>
                <DatePicker className="col-33" label="Ngày rút đơn" bindValidator={this} channel="formTaoDon" onChange={this.onChange.bind(this, 'ngayRutDon')} value={this.state.ngayRutDon} endDate={new Date()} />
                <TextArea label="Lý do rút đơn"
                  placeholder="Nhập lý do..." onChange={this.onChange.bind(this, 'lyDoDinhChi')} value={this.state.lyDoDinhChi} maxLength={1000} />
              </ShowIf>
              <ShowIf condition={this.props.trangThaiDon != 'DANG_XU_LY'}>
                <Input
                  className="col-33"
                  label="Số quyết định"
                  bindValidator={this}
                  channel="formTaoDon"
                  require
                  onChange={this.onChange.bind(this, 'soQuyetDinhDinhChi')}
                  value={this.state.soQuyetDinhDinhChi}
                  maxLength={255}
                />
                <DatePicker className="col-33" label="Ngày ra quyết định" endDate={new Date()} bindValidator={this} channel="formTaoDon" require onChange={this.onChange.bind(this, 'ngayQuyetDinhDinhChi')} value={this.state.ngayQuyetDinhDinhChi} />
                <TextArea label="Lý do rút đơn"
                  bindValidator={this} channel="formTaoDon" require placeholder="Nhập lý do..." onChange={this.onChange.bind(this, 'lyDoDinhChi')} value={this.state.lyDoDinhChi} maxLength={1000} />
              </ShowIf>
              <div className='col-100'>
                <h3 className="txt-12 txt-bold txt-upper mb10 mt0">Đơn xin rút đơn</h3>
                <div className="desc mb10">
                  <p style={{ marginLeft: 0 }}>Định dạng tập tin đính kèm: .doc, .docx, .pdf, .rar, .zip, .jpg, .png. Dung lượng tối đa: 50MB</p>
                </div>
                <div className="result-upload mb20">
                  <div className="items-upload mb10">
                    <ShowIf condition={this.state.progress > 0}>
                      <div className="pt-progress-bar progress-upload pt-intent-primary">
                        <div className="pt-progress-meter"
                          style={{ width: `${this.state.progress}%` }} >
                        </div>
                      </div>
                    </ShowIf>
                    <ShowIf condition={this.state.progress <= 0}>
                      <div className="item-upload">
                        <ShowIf condition={this.state.emptyFile && this.state.duongDan == ''}>
                          <span className='pt-form-helper-text'>Vui lòng đính kèm tài liệu &nbsp;</span>
                        </ShowIf>
                        <ShowIf condition={this.state.duongDan != ''}>
                          <div>
                            <Link onClick={() => { downloadFile(this.state.urlFile, this.state.tenFile) }} className="txt-blue txt-underline mr20 name-file-upload">{this.state.tenFile}</Link>
                            <div className="wrap-upload-item mr15">Tải lại
                              <input type="file" className="btn-reupload" onChange={this.uploadFile.bind(this)} />
                            </div>
                            <Link className="itt-delete" onClick={this.handleRemove.bind(this)}>Xóa</Link>
                          </div>
                        </ShowIf>
                        <ShowIf condition={this.state.duongDan == ''}>
                          <div className="wrap-upload-item mr15">Tải lên
                            <input type="file" className="btn-reupload" onChange={this.uploadFile.bind(this)} />
                          </div>
                        </ShowIf>
                      </div>
                    </ShowIf>
                  </div>
                </div>
              </div>

              <div className="box-bottom col-100">
                <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
                <Link className={this.state.btnLoading ? "btn-action btn-save action-todo btn-loading-inline" : "btn-action btn-save action-todo"} onClick={this.handleDinhChi.bind(this)}><span>Đồng ý</span></Link>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

SuspendedDialog.defaultProps = {
  validators: {},
  type: "GIAI_QUYET_DON"
}

export default connect()(SuspendedDialog);



// WEBPACK FOOTER //
// ./src/components/modules/dialog/SuspendedDialog.jsx